import React from 'react';
import '../App.css';
import SlidingBanner from '../Components/SlidingBanner';
import HeaderTop from '../Components/header';
import Sidebar from '../Components/Sidebar';
import MyCalender from './CheckAvailablity/Availability';
import Services from './Services/Services';
import AboutSection from '../Components/AboutSection';
import EventGallery from '../Components/EventGallery';
import ContactSection from '../Components/ContactSection';
import Footer from '../Components/Footer';

function Index() {
  return (
    <div className="App">
      <Sidebar />
      <HeaderTop />
      <SlidingBanner />
      <MyCalender />
      <AboutSection />
      <Services />
      <EventGallery />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default Index;
